import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar traducciones
import esTranslations from '../locales/es/estiloAprendizaje.json';
import enTranslations from '../locales/en/estiloAprendizaje.json';

// Obtener el idioma de la URL
const getLanguageFromUrl = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  return lang && ['es', 'en'].includes(lang) ? lang : 'es';
};

const resources = {
  es: {
    translation: esTranslations
  },
  en: {
    translation: enTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromUrl(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false // React ya escapa por defecto
    }
  });

// Función para actualizar el idioma cuando cambie la URL
export const updateLanguageFromUrl = () => {
  const newLang = getLanguageFromUrl();
  if (i18n.language !== newLang) {
    i18n.changeLanguage(newLang);
  }
};

export default i18n;
